import { fetchDesktopMarkAllAsRead } from '../../../repositories/notification-center/v1/desktop-mark-all-as-read';
import { TThunkAction } from '../../../types/redux';
import { markAllAsReadFailed } from './markAllAsReadFailed';
import { markAllAsReadLoading } from './markAllAsReadLoading';
import { markAllAsReadSucceed } from './markAllAsReadSucceed';

export const markAllAsRead = (): TThunkAction<Promise<void>> => {
  return async (dispatch, getState, context) => {
    const { httpApi, logger } = context;

    dispatch(markAllAsReadLoading());
    try {
      await fetchDesktopMarkAllAsRead({
        httpApi,
        parameters: {},
      });

      dispatch(markAllAsReadSucceed());
    } catch (ex) {
      logger.error(ex, {
        domain: 'markAsReadNotification',
      });

      dispatch(markAllAsReadFailed());
    }
  };
};
